import { ISideMenuData } from './SideMenu.types';
import SideMenuDrawer from './SideMenuDrawer';
import { SideMenuProvider } from './SideMenuProvider';


export type ISideMenuProps = {
    topData: ISideMenuData[] | undefined,
    middleData: ISideMenuData[] | undefined,
    bottomData: ISideMenuData[] | undefined,
}

export function SideMenu(props: ISideMenuProps) {

    return (
        <SideMenuProvider defaultDrawerWidth={290}>
            <SideMenuDrawer {...props} />
        </SideMenuProvider>
    );
}
